let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lW3nQ")).then(() => parcelRequire('2DnGo'));